/**
 * Niet in het origineel: kunnen de gekozen opleidingen van monteurs ook echt? Het origineel
 * liet de kaart "van kennisniveau 4 naar 5" kiezen zonder monteur op niveau 4. Bij het
 * verwerken was dan niemand te kiezen en liep het spel vast.
 *
 * Telt de monteurs die er nu zijn. "Alle monteurs opleiden" gaat eerst: dat effect past de
 * spelleider meteen toe bij "Alles verwerkt", de andere opleidingen doen de spelers daarna
 * vanuit de wachtrij. Elke opleiding van 4 naar 5 vraagt dan een eigen monteur op niveau 4,
 * elke gewone opleiding een eigen monteur onder niveau 5. Een monteur die door een nieuwe
 * aanname of een gewone opleiding pas later op het goede niveau komt, telt niet mee: liever
 * een keer te voorzichtig dan een spel dat vastloopt.
 */
import { getSpecificTaskData } from '../data/taken.js';
import { InGameEffect } from '../types/inGameEffect.js';
/** Of een taak monteurs opleidt (gewoon, van 4 naar 5 of allemaal tegelijk). */
export function isOpleiding(taak) {
    return (taak.inGameEffect ?? []).some((effect) => effect === InGameEffect.upgradeMechanic ||
        effect === InGameEffect.upgradeMechanic4to5 ||
        effect === InGameEffect.upgradeAllMechanics);
}
/** Of deze monteur bij dit effect opgeleid kan worden. */
export function kanOpleiden(effect, monteur) {
    if (effect === InGameEffect.upgradeMechanic)
        return monteur.knowledgeLevel < 5;
    if (effect === InGameEffect.upgradeMechanic4to5)
        return monteur.knowledgeLevel === 4;
    return false;
}
/** Wat er misgaat met de opleidingen in deze taken samen, of `undefined` als ze kunnen. */
export function opleidingProbleem(monteurs, taakIds) {
    const effecten = getSpecificTaskData(taakIds).flatMap((taak) => taak.inGameEffect ?? []);
    const aantal = (soort) => effecten.filter((e) => e === soort).length;
    let niveaus = monteurs.map((m) => m.knowledgeLevel);
    for (let i = 0; i < aantal(InGameEffect.upgradeAllMechanics); i++) {
        // Zit iedereen al op niveau 5, dan levert de opleiding voor iedereen niets op.
        if (!niveaus.some((niveau) => niveau < 5))
            return 'niemandOpTeLeiden';
        niveaus = niveaus.map((niveau) => (niveau < 5 ? niveau + 1 : niveau));
    }
    const vierNaarVijf = aantal(InGameEffect.upgradeMechanic4to5);
    const gewoon = aantal(InGameEffect.upgradeMechanic);
    if (vierNaarVijf > niveaus.filter((niveau) => niveau === 4).length)
        return 'geenMonteurOp4';
    if (vierNaarVijf + gewoon > niveaus.filter((niveau) => niveau < 5).length) {
        return 'niemandOpTeLeiden';
    }
    return undefined;
}
/** Of alle opleidingen in deze taken samen een monteur hebben om op te leiden. */
export function opleidingenKunnen(monteurs, taakIds) {
    return opleidingProbleem(monteurs, taakIds) === undefined;
}
